import React from "react";
import {List, DatePicker, TextareaItem, Toast} from 'antd-mobile';

import applicationCenterService from '../../services/Employee/application-center-service';

import MobileWrapper from '../../layouts/MobileWrapper';


class MobileApplyGoOutCreate extends React.Component {

    constructor(props) {
        super(props)


        this.state = {
            start: null,
            end: null,
            remark: ""
        }
    }


    formatDate = (date, type) => {
        const pad = n => n < 10 ? `0${n}` : n;
        const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
        const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`;

        if (type === 'time') {
            return `${timeStr}`
        } else {
            return `${dateStr}`
        }
    }


    handleChange = (event) => {

        this.setState({remark: event});
    }


    onSubmit = () => {


        if(this.state.start == null){
            Toast.fail("请选择开始时间！", 4);
            return false;
        }

        if(this.state.end == null){
            Toast.fail("请选择结束时间！", 4);
            return false;
        }

        if(this.state.remark == null || this.state.remark === ""){
            Toast.fail("请填写事由！", 4);
            return false;
        }



        let posts = {
            end_date: this.formatDate(this.state.end, "date"),
            end_time: this.formatDate(this.state.end, "time"),
            start_time: this.formatDate(this.state.start, "time"),
            start_date: this.formatDate(this.state.start, "date"),
            remark: this.state.remark
        }

        applicationCenterService.addApplyGoOut(posts, res => {
            if (res.data.Success) {
                Toast.success("外出申请操作成功", 4);

                this.setState({remark: ""});
                this.setState({start: null});
                this.setState({end: null});

            } else {
                Toast.fail(`外出申请操作失败：${res.data.Errors[0]}`,4);
            }
        }, err => {
        });

    }

    render() {


        return <form>
            <List style={{backgroundColor: 'white'}} className="picker-list">



                <DatePicker
                    value={this.state.start}
                    onChange={date => this.setState({ start:date })}
                >
                    <List.Item arrow="horizontal">开始时间</List.Item>
                </DatePicker>

                <DatePicker
                    value={this.state.end}
                    onChange={date => this.setState({ end: date })}
                >
                    <List.Item arrow="horizontal">结束时间</List.Item>
                </DatePicker>


                

                <TextareaItem
                    title="外出事由"
                    placeholder="外出事由"
                    value={this.state.remark}
                    rows={5}
                    onChange={this.handleChange}

                />


                <List.Item>
                    <div
                        style={{width: '100%', color: '#108ee9', textAlign: 'center'}}
                        onClick={this.onSubmit}
                    >
                        保存
                    </div>
                </List.Item>

            </List>
        </form>


    }
}

export default MobileWrapper(MobileApplyGoOutCreate);


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileApplyGoOutCreate.js